export enum ActiveTicketCategory {
  INCIDENT = 'INCIDENT',
  OBSERVATION = 'OBSERVATION',
  OBJECT_FOUND = 'OBJECT_FOUND',
}
